module.exports = __webpack_public_path__ + "static/media/No.628acc97.svg";